import { useEffect, useState } from 'react'

/**
 * The value, once it has stopped changing for `delayMs`.
 *
 * What it buys: a search box that queries the server on every keystroke sends
 * one request per letter and paints whichever answer lands last, which is not
 * necessarily the answer to what the shopper typed. Debouncing the *term* — not
 * the input — keeps the box responsive (it renders the raw value) while the
 * query only ever sees settled text.
 *
 * `useDebouncedCartQuantity` debounces too, but it cannot be reused here: it
 * settles a `sku -> quantity` map into mutations, one timer per sku. This is one
 * timer over one value.
 */
export const useDebouncedValue = <T,>(value: T, delayMs: number): T => {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs)
    return () => clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
